import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_balloon_actions = _resolveComponent("balloon-actions")

  return ($options.hasActions)
    ? (_openBlock(), _createBlock(_component_balloon_actions, {
        key: 0,
        actions: $options.actions,
        mode: $options.balloonActionsMode,
        "balloon-style-props": $options.balloonStyleProps,
        theme: "secondaryAlt"
      }, null, 8 /* PROPS */, ["actions", "mode", "balloon-style-props"]))
    : _createCommentVNode("v-if", true)
}